import { render, staticRenderFns } from "./PaymentBanner.vue?vue&type=template&id=8b09fc14&scoped=true"
import script from "./PaymentBanner.vue?vue&type=script&lang=js"
export * from "./PaymentBanner.vue?vue&type=script&lang=js"
import style0 from "./PaymentBanner.vue?vue&type=style&index=0&id=8b09fc14&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b09fc14",
  null
  
)

export default component.exports